import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ApartmentBlockIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-apartmentBlock"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M34 18.5a5 5 0 0 0-5 5 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5 5 5 0 0 0-5-5m.2 1.005a4 4 0 0 1 3.757 3.404l.01.091h-7.935l.011-.091A4 4 0 0 1 34 19.5z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M46 0H21v33h25zm-1 1v31H22V1z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M28.5 4h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5M28 5v3h-3V5zm7.5-1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5M35 5v3h-3V5zm7.5-1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5M42 5v3h-3V5zm-13.5 6h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m-.5 1v3h-3v-3zm7.5-1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m-.5 1v3h-3v-3zm7.5-1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m-.5 1v3h-3v-3zM59 33v1H9v-1zM60.522 16.457l1.12 1.657a25 25 0 0 0-2.116 1.6c-2.327 1.973-3.861 4.069-4.765 6.151a11 11 0 0 0-.652 1.965l-.03.137-.058.328-.019.145-.004.05-1.996-.122c.043-.704.297-1.854.924-3.3 1.024-2.359 2.742-4.705 5.307-6.88a26 26 0 0 1 1.803-1.395z"
        />
        <path fill="#424242" fillRule="nonzero" d="M54 13.571V34h-2V13.571z" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M45.48 16.457a27 27 0 0 1 2.288 1.732c2.564 2.173 4.282 4.52 5.306 6.88.585 1.349.845 2.44.912 3.152l.012.146-1.996.123-.012-.115-.046-.284-.053-.261a11 11 0 0 0-.652-1.965c-.904-2.082-2.438-4.178-4.764-6.15a24 24 0 0 0-1.666-1.29l-.45-.311z"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M61.131 14.32c.07-.271.119-.552.119-.846a3.43 3.43 0 0 0-3.438-3.421c-.556 0-1.074.144-1.538.377A3.43 3.43 0 0 0 53 8a3.425 3.425 0 0 0-3.274 2.43 3.4 3.4 0 0 0-1.539-.377 3.43 3.43 0 0 0-3.437 3.42c0 .295.049.576.119.848-1.664.44-2.869 1.732-2.869 3.258 0 1.89 1.847 3.42 4.125 3.42 1.155 0 2.198-.393 2.946-1.028C50.07 20.606 51.46 21 53 21s2.93-.394 3.929-1.03c.748.636 1.791 1.03 2.946 1.03C62.153 21 64 19.469 64 17.579c0-1.526-1.205-2.817-2.869-3.258"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="m22.522 16.457 1.12 1.657a25 25 0 0 0-2.116 1.6c-2.327 1.973-3.861 4.069-4.765 6.151a11 11 0 0 0-.652 1.965l-.03.137-.058.328-.019.145-.004.05-1.996-.122c.043-.704.297-1.854.924-3.3 1.024-2.359 2.742-4.705 5.307-6.88a26 26 0 0 1 1.803-1.395z"
        />
        <path fill="#424242" fillRule="nonzero" d="M16 13.571V34h-2V13.571z" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M7.48 16.457a27 27 0 0 1 2.288 1.732c2.564 2.173 4.282 4.52 5.306 6.88.585 1.349.845 2.44.912 3.152l.012.146-1.996.123-.012-.115-.046-.284-.053-.261a11 11 0 0 0-.652-1.965c-.904-2.082-2.438-4.178-4.764-6.15a24 24 0 0 0-1.666-1.29l-.45-.311z"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M23.131 14.32c.07-.271.119-.552.119-.846a3.43 3.43 0 0 0-3.438-3.421c-.556 0-1.074.144-1.538.377A3.43 3.43 0 0 0 15 8a3.425 3.425 0 0 0-3.274 2.43 3.4 3.4 0 0 0-1.539-.377 3.43 3.43 0 0 0-3.437 3.42c0 .295.049.576.119.848C5.205 14.76 4 16.053 4 17.579c0 1.89 1.847 3.42 4.125 3.42 1.155 0 2.198-.393 2.946-1.028C12.07 20.606 13.46 21 15 21s2.93-.394 3.929-1.03c.748.636 1.791 1.03 2.946 1.03C24.153 21 26 19.469 26 17.579c0-1.526-1.205-2.817-2.869-3.258M31 32h6v-8h-6z"
        />
        <path fill="#424242" fillRule="nonzero" d="M47 0v2H20V0z" />
      </g>
    </Icon>
  )
}
